import { useEffect, useRef, useState } from "react";
import { ChevronRight } from "lucide-react";
import { occasionTone } from "./appData";

export default function OccasionCard({ eventKey, label, img, selected = false, arrow = true, onPick, testId, delay = 0 }) {
  const key = img || eventKey;
  const [loaded, setLoaded] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    if (imgRef.current?.complete) setLoaded(true);
  }, []);

  return (
    <button type="button"
      data-testid={testId}
      data-ev={eventKey}
      aria-pressed={selected || undefined}
      className={"oc oc--" + occasionTone(eventKey) + (selected ? " is-selected" : "") + (arrow ? "" : " no-arrow")}
      style={delay ? { animationDelay: delay + "ms" } : undefined}
      onClick={() => onPick?.(eventKey)}>
      <span className="oc-media" aria-hidden="true">
        <picture>
          <source type="image/webp" srcSet={"/design/events3d/" + key + ".webp"} />
          <img ref={imgRef} src={"/design/events3d/" + key + ".png"} alt=""
            loading="lazy" decoding="async"
            className={loaded ? "is-loaded" : ""}
            onLoad={() => setLoaded(true)} />
        </picture>
      </span>
      <span className="oc-title">{label}</span>
      {arrow && <span className="oc-action" aria-hidden="true"><ChevronRight size={21} /></span>}
    </button>
  );
}
